<!-- eslint-disable quotes -->
<template>
  <div
    v-if="invoice"
    class="checkout-container-right"
  >
    <!-- Top Header -->
    <TopHeaderComponent :exit="exit" />

    <div class="details-container">
      <!-- Breadcrumbs -->
      <BreadcrumbComponent :bread-crumbs="breadCrumbs" />

      <form
        name="payment-form"
        noValidate
        @submit.prevent="submitPaymentForReview()"
      >
        <div
          v-show="invoice && invoice.payment_status === 'unpaid'"
          class="details-inner-container"
        >
          <div class="payment-info-component">
            <h1>Payment Info</h1>

            <span class="subtitle">Choose payment method</span>

            <PaymentMethodListComponent
              :invoice="invoice"
              :show-loading-message="showLoadingMessage"
              :show-error="showError"
            />

            <TaxExemptStatusComponent
              v-if="shouldShowTaxExemptStatus"
              :loading-exemption-status="loadingExemptionStatus"
              :exemption-status="invoice ? invoice.exemption_status : {}"
              :toggle-upload-certificate-form="toggleUploadCertificateForm"
            />

            <hr class="hr-design">
          </div>

          <!-- Payment stuff goes here -->
          <button
            v-if="isThinking"
            class="disabledButton continue-btn"
            disabled="disabled"
          >
            <span
              class="loading"
              style="display: inline-block"
            />
          </button>
          <button
            v-else
            :class="{
              'continue-btn': true,
            }"
            :disabled="paymentIsReady === false"
          >
            {{ buttonText }}
          </button>
        </div>
      </form>
      <!-- End of payment info .details-inner-container -->

      <div
        v-show="shouldShowPaymentComplete"
        class="details-inner-container"
      >
        <div class="shipping-options-container">
          <h1>Payment Info</h1>
          <p class="subtitle">
            Thank you for your purchase.
          </p>
        </div>
      </div>
      <!-- End of payment complete .details-inner-container -->
    </div>

    <!-- Bottom Footer -->
    <BottomFooterComponent
      :exit="exit"
      :customer-name="customerName"
      :is-staff-view="isStaffView"
    />
  </div>
</template>

<script>
import apiMixin from '../../../mixins/apiMixin.js'
import BottomFooterComponent from '../Shared/BottomFooterComponent.vue'
import BreadcrumbComponent from '@/components/Checkout/Shared/BreadcrumbComponent.vue'
import InvoiceValidateMixin from '@/mixins/InvoiceValidateMixin.js'
import PaymentMethodListComponent from '@/components/Checkout/PaymentInfo/PaymentMethodListComponent.vue'
import TaxExemptStatusComponent from '@/components/Checkout/PaymentInfo/TaxExemptStatusComponent.vue'
import TopHeaderComponent from '../Shared/TopHeaderComponent.vue'
import TotalReviewBar from '../Shared/TotalReviewBar.vue'
import ApiError from '../../../errors/ApiError.js'

export default {
	name: 'PaymentCollectionComponent',
	components: {
		BottomFooterComponent,
		BreadcrumbComponent,
		PaymentMethodListComponent,
		TaxExemptStatusComponent,
		TopHeaderComponent,
		TotalReviewBar
	},
	mixins: [apiMixin, InvoiceValidateMixin],
	props: [
		'invoice',
		'loadingExemptionStatus',
		'creditCardPaymentRestricted',
		'radioPicked',
		'checkRestricted',
		'zelleRestricted',
		'isThinking',
		'breadCrumbs',
		'isStaffView',
		'customerName',
		'toggleUploadCertificateForm',
		'updateLoading',
		'showError',
		'updatePaymentType',
		'showLoadingMessage',
		'showReviewPayment'
	],
	data: function () {
		return {
			paymentIsReady: false,
			buttonText: 'Complete Payment'
		}
	},
	computed: {
		shouldShowPaymentComplete: function () {
			return (
				this.invoice &&
				(this.invoice.payment_status === 'overpaid' ||
					this.invoice.payment_status === 'paid')
			)
		},
		shouldShowTaxExemptStatus: function () {
			return (
				this.isStaffView === false &&
				this.invoice &&
				this.containsWineOrSpirits(this.invoice) === false
			)
		},
		paymentFormStore () {
			return this.$store.getters.paymentForm
		},
		inventory_ids: function () {
			let tempInvoice = this.invoice
			let out = []
			if (tempInvoice && typeof tempInvoice.invoice_items === 'undefined') {
				return out
			}
			if (tempInvoice && tempInvoice.invoice_items) {
				for (let i = 0; i < tempInvoice.invoice_items.length; i++) {
					let item = tempInvoice.invoice_items[i]
					if (item.inventory_id > 0) {
						out.push(item.inventory_id)
					}
				}
			}
			return out
		}
	},
	watch: {
		paymentFormStore: function () {
			// Set the Button Text
			if (this.paymentFormStore) {
				if (this.paymentFormStore.type === 'credit_card') {
					this.buttonText = 'Review Payment'
				} else if (this.paymentFormStore.type === 'paypal') {
					this.buttonText = 'Review Payment'
				} else if (this.paymentFormStore.type === 'apple_pay') {
					this.buttonText = 'Review Payment'
				} else if (this.paymentFormStore.type === 'google_pay') {
					this.buttonText = 'Review Payment'
				} else if (this.paymentFormStore.type === 'venmo') {
					this.buttonText = 'Review Payment'
				} else {
					this.buttonText = 'Complete Payment'
				}
			}
			if (this.paymentFormStore && this.paymentFormStore.type === 'credit_card' && this.paymentFormStore.savedPaymentMethod === false && (this.paymentFormStore.nonce !== undefined && this.paymentFormStore.nonce !== null)) {
				// Credit card was selected, and we have a nonce, show the review paymet modal
				this.submitPaymentForReview()
			} else if (this.paymentFormStore && this.paymentFormStore.type === 'credit_card' && this.paymentFormStore.savedPaymentMethod === true && (this.paymentFormStore.nonce !== undefined && this.paymentFormStore.nonce !== null)) {
				// User picked a saved/vaulted credit card
				this.paymentIsReady = true
			} else if (this.paymentFormStore && this.paymentFormStore.type === 'credit_card') { // credit card was selected but no nonce, enable the review payment button
				this.paymentIsReady = true
			} else {
				if (this.paymentFormStore && (this.paymentFormStore.nonce !== undefined && this.paymentFormStore.nonce !== null)) {
					// We have a nonce!
					this.paymentIsReady = true
					return
				}
				if (this.paymentFormStore && (this.paymentFormStore.type === 'zelle' || this.paymentFormStore.type === 'wire_transfer')) {
					this.paymentIsReady = true
					return
				}
				this.paymentIsReady = false
			}
		}
	},
	mounted: function () {
	},
	methods: {
		submitPayment: function () {
			// We have a nonce, submit to the api
			if (this.paymentFormStore.nonce !== undefined && this.paymentFormStore.nonce !== null) {
				let type = ''
				if (this.paymentFormStore.type === 'credit_card') {
					this.updatePaymentType('credit_card')
					type = 'CreditCard'
				} else if (this.paymentFormStore.type === 'paypal') {
					this.updatePaymentType('paypal')
					type = 'PayPalAccount'
				} else if (this.paymentFormStore.type === 'apple_pay') {
					this.updatePaymentType('apple_pay')
					type = 'ApplePayCard'
				} else if (this.paymentFormStore.type === 'google_pay') {
					this.updatePaymentType = 'google_pay'
					type = 'GooglePayCard'
				} else if (this.paymentFormStore.type === 'venmo') {
					this.updatePaymentType('venmo')
					type = 'VenmoAccount'
				} else if (this.paymentFormStore.type === 'e_check') {
					this.updatePaymentType('ach')
					type = 'ACH'
				}

				if (this.paymentFormStore.isPartialPayment && this.paymentFormStore.amount && this.paymentFormStore.amount > 0) {
					this.chargePartialPayment(type, this.paymentFormStore.amount)
				} else {
					this.chargeWithBraintree(type)
				}
			}
		},
		/**
		 * Called when user clicks the submit button
		 */
		submitPaymentForReview: function () {
			if (this.buttonText === 'Review Payment') {
				if (this.paymentFormStore &&
					this.paymentFormStore.type === 'credit_card' &&
					(!this.paymentFormStore.savedPaymentMethod || this.paymentFormStore.savedPaymentMethod === false) && // if there's no savedPaymentMethod set, or it's set and is false, then we know it's not a saved card
					(this.paymentFormStore.nonce === undefined || this.paymentFormStore.nonce === null)) {
					// If credit card was selected, trigger the CreditCardComponent to submit and get a nonce, which will loop back here and land in the if statement above
					const paymentForm = {
						...this.paymentFormStore,
						submitCC: true // This tells the CreditCardComponent to submit it's form to Braintree and get a nonce
					}

					this.$store.dispatch('updatePaymentForm', paymentForm)
				}

				if (this.paymentFormStore.isPartialPayment && this.paymentFormStore.amount && this.paymentFormStore.amount > 0) {
					this.showReviewPayment(true, true, this.paymentFormStore.amount)
				} else {
					this.showReviewPayment(true, false, 0)
				}
			} else {
				if (this.paymentFormStore.type === 'e_check') {
					this.submitPayment()
				}
				if (this.paymentFormStore.type === 'zelle') {
					this.updatePaymentType('zelle')
					this.chargeWithZelle()
				} else if (this.paymentFormStore.type === 'wire_transfer') {
					this.updatePaymentType('wire')
					this.chargeWithWireTransfer()
				}
			}

			//   this.$store.dispatch('updatePaymentForm', paymentForm)
		},
		/**
		 * Pass payment nonce to server
		 * @param {String} braintreeType
		 */
		chargeWithBraintree: async function (braintreeType) {
			this.updateLoading(true, true)
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pay_and_ship'
			apiPayload.postData.inventory_ids = this.inventory_ids
			apiPayload.postData.paymentType = 'braintree'
			apiPayload.postData.useArta = this.canUseArta(this.invoice)
			apiPayload.postData.paymentMethodNonce = this.paymentFormStore.nonce
			apiPayload.postData.streetAddress = this.paymentFormStore.streetAddress
			apiPayload.postData.braintreeType = braintreeType // can be PayPalAccount
			apiPayload.postData.braintreeDeviceData = this.paymentFormStore.deviceData
			apiPayload.postData.usingVaultedPaymentMethod = this.paymentFormStore.savedPaymentMethod

			const response = await this.$store.dispatch('apiCall', apiPayload).catch(error => {
				this.handleApiException(error)
			})

			if (!response || response.data.result !== 'success') {
				if (response && response.data) {
					const error = new Error(response.data.message)
					this.handleApiException(error)
					return
				}
				// at this point just tell the customer to call Leland Little to avoid risk of double-payment
				const error = new Error('Payment failed')
				this.handleApiException(error)
				return
			}

			this.updateLoading(true, false)
		},
		chargePartialPayment: async function (braintreeType, amount) {
			this.showLoadingMessage(true, 'Your payment is being processed. Please do not leave this screen.')
			let apiPayload = {}
			apiPayload.apiEndpoint = 'invoice'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pay_partial_amount'
			apiPayload.postData.inventory_ids = this.inventory_ids
			apiPayload.postData.paymentType = 'braintree'
			apiPayload.postData.paymentMethodNonce = this.paymentFormStore.nonce
			apiPayload.postData.amount = amount
			apiPayload.postData.streetAddress = this.paymentFormStore.streetAddress
			apiPayload.postData.braintreeType = braintreeType // can be PayPalAccount
			apiPayload.postData.braintreeDeviceData = this.paymentFormStore.deviceData
			apiPayload.postData.usingVaultedPaymentMethod = this.paymentFormStore.savedPaymentMethod

			const response = await this.$store.dispatch('apiCall', apiPayload).catch(error => {
				this.handleApiException(error)
			})

			this.showLoadingMessage(false, '')

			if (!response || response.data.result !== 'success') {
				// at this point just tell the customer to call Leland Little to avoid risk of double-payment
				this.handleApiException(new Error('Payment failed'))
				return
			}
			if (response.data.payload.success === true) {
				location.reload()
			} else {
				this.showError(true, 'Payment Failed', 'Something went wrong processing your payment.')
			}
		},
		/**
		 * Send Zelle payment indication to server
		 */
		chargeWithZelle: function () {
			this.updateLoading(true, true)

			let apiPayload = {}
			apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pay_and_ship'
			apiPayload.postData.inventory_ids = this.inventory_ids
			apiPayload.postData.paymentType = 'zelle'
			apiPayload.postData.useArta = this.canUseArta(this.invoice)
			this.$store.dispatch('apiCall', apiPayload).then(response => {
				if (response.data.result !== 'success') {
					// at this point just tell the customer to call Leland Little to avoid risk of double-payment
					this.handleApiException(new Error('Payment failed'))
					return
				}

				this.updateLoading(true, false)
			})
				.catch(error => {
					this.handleApiException(error)
				})
		},
		/**
		 * Send wire transfer payment indication to server
		 */
		chargeWithWireTransfer: function () {
			this.updateLoading(true, true)
			let apiPayload = {}
			apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pay_and_ship'
			apiPayload.postData.inventory_ids = this.inventory_ids
			apiPayload.postData.paymentType = 'wire'
			apiPayload.postData.useArta = this.canUseArta(this.invoice)
			this.$store.dispatch('apiCall', apiPayload).then(response => {
				if (response.data.result !== 'success') {
					// at this point just tell the customer to call Leland Little to avoid risk of double-payment
					this.handleApiException(new Error('Payment failed'))
					return
				}

				this.updateLoading(true, false)
			})
				.catch(error => {
					this.handleApiException(error)
				})
		},
		/**
		 * Handle API exceptions
		 * @param {Error} error
		 */
		handleApiException (error) {
			const exception = new ApiError(error)
			console.error(exception)
			this.updateLoading(false, true)
			let title = 'Something went wrong...'
			let message = 'There was an error processing your payment and shipping request. Please contact Leland Little for assistance.'
			switch (exception.message) {
			case 'Sorry, international cards are not accepted.':
				message = exception.message
				break
			}
			this.openError(title, message)
		},
		/**
		 * Open error modal
		 * @param {String} title
		 * @param {String} message
		 * @param {String} details
		 */
		openError (title, message, details) {
			this.updateLoading(false, false)
			let errorTitle = ''
			let errorMessage = ''
			if (typeof title === typeof 'asdf') {
				errorTitle = title
			}
			if (typeof message === typeof 'asdf') {
				errorMessage = message
			}
			this.showError(true, errorTitle, errorMessage)
		},
		/**
		 * Exit checkout
		 */
		exit () {
			const referrer = localStorage.getItem('exit-referrer')
			if (referrer) {
				// If we have a exit-referrer, redirect to it
				window.location.replace(referrer)
				return
			}
			// Otherwise, redirect to the home page
			window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
		}
	}
}
</script>
